import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { profileService } from '../services/profile.service';

export const useUserDisplayName = () => {
  const { user } = useAuth();
  const [displayName, setDisplayName] = useState<string>('User');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!user) {
        setDisplayName('User');
        setIsLoading(false);
        return;
      }

      try {
        // Intentar obtener el perfil del usuario
        const profile = await profileService.getUserProfile();

        // Construir el nombre para mostrar según el tipo de cuenta
        let name = '';

        // Si es CORPORATE, usar el nombre de la empresa
        if (profile.accountType === 'CORPORATE') {
          if (profile.corporateInfo?.companyName) {
            name = profile.corporateInfo.companyName;
          } else if (profile.onboardingCorporate?.companyName) {
            name = profile.onboardingCorporate.companyName;
          }
        }

        // Si no es CORPORATE o no tiene nombre de empresa, usar nombre personal
        if (!name.trim() && profile.firstName) {
          name = profile.firstName;

          // Agregar middleName si existe
          if (profile.middleName) {
            name += ` ${profile.middleName}`;
          }
        }

        // Si no hay nombre, usar la parte del email antes del @
        if (!name.trim()) {
          name = user.email?.split('@')[0] || 'User';
        }

        setDisplayName(name);
      } catch (error) {
        console.error('Error fetching user profile for display name:', error);
        // Fallback al email si hay error
        setDisplayName(user.email?.split('@')[0] || 'User');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserProfile();
  }, [user]);

  return { displayName, isLoading };
};